import { KeyboardArrowUp } from '@mui/icons-material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React, { useMemo } from 'react';
import { Task } from '../../types/public-types';
import styles from './task-list-table.module.css';

const localeDateStringCache: any = {};
const toLocaleDateStringFactory = (locale: string) => (date: Date, dateTimeOptions: Intl.DateTimeFormatOptions) => {
  const key = date.toString();
  let lds = localeDateStringCache[key];
  if (!lds) {
    lds = date.toLocaleDateString(locale, dateTimeOptions);
    localeDateStringCache[key] = lds;
  }
  return lds;
};
const dateTimeOptions: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  year: 'numeric',
  month: 'long',
  day: 'numeric'
};

export const TaskListTableDefault: React.FC<{
  rowHeight: number;
  rowWidth: string;
  fontFamily: string;
  fontSize: string;
  locale: string;
  tasks: Task[];
  selectedTaskId: string;
  setSelectedTask: (taskId: string) => void;
  onExpanderClick: (task: Task) => void;
}> = ({ rowHeight, rowWidth, tasks, fontFamily, fontSize, locale, onExpanderClick }) => {
  const toLocaleDateString = useMemo(() => toLocaleDateStringFactory(locale), [locale]);

  return (
    <div
      className={styles.taskListWrapper}
      style={{
        fontFamily,
        fontSize
      }}
    >
      {tasks.map(t => {
        let expanderSymbol = '';
        // if (t.hideChildren === false) {
        //   expanderSymbol = '▼';
        // } else if (t.hideChildren === true) {
        //   expanderSymbol = '▲';
        // }

        if (t.hideChildren === false) {
          expanderSymbol = 'down';
        } else if (t.hideChildren === true) {
          expanderSymbol = 'up';
        }

        return (
          <div className={styles.taskListTableRow} style={{ height: rowHeight }} key={`${t.id}row`}>
            <div
              className={styles.taskListCell}
              style={{
                minWidth: rowWidth,
                maxWidth: rowWidth,
                cursor: 'pointer'
              }}
              title={t.name}
              onClick={() => onExpanderClick(t)}
            >
              <div className={styles.taskListNameWrapper}>
                {/* <div className={expanderSymbol ? styles.taskListExpander : styles.taskListEmptyExpander}>
                  {expanderSymbol}
                </div> */}
                <div className={expanderSymbol ? styles.taskListExpander : styles.taskListEmptyExpander}>
                  {expanderSymbol === 'down' ? (
                    <KeyboardArrowDownIcon color="primary" />
                  ) : expanderSymbol === 'up' ? (
                    <KeyboardArrowUp color="primary" />
                  ) : (
                    ''
                  )}
                </div>
                <div>{t.type === 'project' ? t.name : ''}</div>
              </div>
            </div>
            <div
              className={styles.taskListCell}
              style={{
                minWidth: rowWidth,
                maxWidth: rowWidth
              }}
            >
              &nbsp;{toLocaleDateString(t.start, dateTimeOptions)}
            </div>
            <div
              className={styles.taskListCell}
              style={{
                minWidth: rowWidth,
                maxWidth: rowWidth
              }}
            >
              &nbsp;{toLocaleDateString(t.end, dateTimeOptions)}
            </div>
          </div>
        );
      })}
    </div>
  );
};
